module.exports = __webpack_public_path__ + "static/media/search-document-white.11ad31e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/search-document-white.svg
// module id = 1497
// module chunks = 0